/**
 *  表单校验，照着formily源码submit那部分写的。 这部分不这么写，直接调用 form.validate()会清除effects里set的error，比较奇怪。
 */
export const formValidate = async (actions, path = '') => {
  await actions.validate(path, {
    throwErrors: false,
    hostRendering: true
  });
  const validated = actions.getFormState(state => ({
    errors: state.errors
  }));
  const {
    errors
  } = validated; // 校验失败

  if (errors.length) {
    throw errors;
  }
};
//# sourceMappingURL=es/utils/formValidate.js.map